//
// 定数
//

// unix epoch
export const MILLI_SECOND = 1
export const SECOND = 1000 * MILLI_SECOND
export const MINUTE = 60 * SECOND
export const HOUR = 60 * MINUTE
export const DAY = 24 * HOUR

// ymd
export const YEAR = 10000
export const MONTH = 100
export const DATE = 1

export const FMT_DATE = 'Y/m/d'
export const FMT_DATETIME = 'Y/m/d H:i:s'
export const FMT_DATETIME_MSEC = 'Y/m/d H:i:s.v'
